import { useEffect, useState } from "react";

const navLinks = [
  { label: "最新拉片", href: "#feed" },
  { label: "分析维度", href: "#dimensions" },
  { label: "话题墙", href: "#topics" },
  { label: "背景疑点", href: "#suspicions" },
  { label: "方法论", href: "#method" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleTheme = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <a
          href="#top"
          className="flex items-center gap-2.5 cursor-pointer"
          aria-label="黑料视频 首页"
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-scan-2-line text-lg leading-none"></i>
          </span>
          <span
            className={`font-heading font-bold text-lg tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            黑料视频
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm whitespace-nowrap transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={toggleTheme}
            aria-label="切换深浅色"
            className={`w-9 h-9 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
              scrolled
                ? "border-background-200 text-foreground-700 hover:bg-background-100"
                : "border-background-50/25 text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={`${dark ? "ri-sun-line" : "ri-moon-line"} text-base leading-none`}></i>
          </button>
          <a
            href="#feed"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-play-list-2-line text-base leading-none"></i>
            开始拉片
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md border cursor-pointer ${
              scrolled
                ? "border-background-200 text-foreground-800"
                : "border-background-50/25 text-background-50"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-lg leading-none`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block py-2.5 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-100 last:border-0"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}